import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StepperV2Component } from './stepper-v2.component';
import { IconsModule } from '../../components/icons';
import { ButtonModule } from '../../components/buttons';
import { ProgressIndicatorModule } from '../progress-indicator/progress-indicator.module';

@NgModule({
  declarations: [StepperV2Component],
  imports: [CommonModule, IconsModule, ButtonModule, ProgressIndicatorModule],
  exports: [StepperV2Component],
})
export class StepperV2Module {}
